import style from "./style.module.css"
import paws1 from "../../../images/footer/paws1.svg"
import paws2 from "../../../images/footer/paws2.svg"
import vipa from "../../../images/footer/iconVipa.svg"
import { useEffect } from "react";
import { toast } from "react-toastify"
import BaseApi from "../../../services/Api";
import React from "react";

const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
};  

export default function Footer(props) {


    return (
        <>

          <footer>
        <div className={style.container}>
            <div className={style.rectangle}>
                <div className={style.paws1}>
                    <img src={paws1} className={style.imgPaws1} alt="patinhas" />
                </div>
                <div className={style.paws2}>
                    <img src={paws2} className={style.imgPaws2} alt="patinhas" />
                </div>
                <div className={style.options}>
                    <div>
                        <a href="/animais" className={style.btn}>Adotar</a>
                        <span> | </span>
                        <a href="/#donation" className={style.btn}>Ajudar </a>
                        <span className={style.bar}> | </span>
                    </div>
                    <div className={style.division}>
                        <a href="/#adopted" className={style.btn}>Animais Adotados </a>
                        <span> | </span>
                        <a href="/#partners" className={style.btn}>Nossos Parceiros </a>
                    </div>
                </div> 
                <div className={style.contact}>
                    {props.informationData.instagram && (
                        <a href={props.informationData.instagram} className={style.at} target="_blank">
                            <i className="d-flex align-items-center bi bi-instagram"></i>
                            <span className={style.space}>Instagram</span>
                        </a>
                    )}
                    {props.informationData.facebook && (
                        <a href={props.informationData.instagram} className={style.at} target="_blank">
                            <i className="d-flex align-items-center bi bi-facebook"></i>
                            <span className={style.space}>Facebook</span>
                        </a>
                    )}
                    {props.informationData.linkedin && (
                        <a href={props.informationData.instagram} className={style.at} target="_blank">
                            <i className="d-flex align-items-center bi bi-linkedin"></i>
                            <span className={style.space}>LinkedIn</span>
                        </a>
                    )}
                </div>
                <div className={style.description}>
                    {props.informationData.description && (
                    <div className={style.spaceDescription}>
                        <span>{props.informationData.description}</span>
                    </div>
                    )}
                    <div className={style.information}>
                    {props.informationData.phone && props.phone && (
                        <div className={style.informationIcon}>
                            <a target="_blank" href={`https://api.whatsapp.com/send?phone=${props.phone}`} className={`${style.btn} d-flex`}>
                            <i class="d-flex align-items-center bi bi-telephone-fill"></i>
                            <span className={style.space}>Telefone: {props.informationData.phone}</span></a>
                        </div>
                    )}
                        {props.informationData.opening_hours && (
                        <div className={style.informationIcon}>
                            <i class="d-flex align-items-center bi bi-clock"></i>
                            <span className={style.space}>Funcionamento: {props.informationData.opening_hours}</span>
                        </div>
                        )}
                        {props.informationData.email && (
                            <div className={style.informationIcon}>
                                <i class="d-flex align-items-center bi bi-envelope-fill"></i>
                                <span className={style.space}>Email: {props.informationData.email}</span>
                            </div>
                        )}
                        
                    </div>
                </div>
            </div>
            <div className={style.baseBoard}>
                <div className={style.iconVipa}>
                    <img src={vipa} className={style.imgVipa} alt="vipa" />
                </div>
                <div className={style.addres}>
                    {props.informationData.addres && (
                        <span>
                            {props.informationData.addres}
                        </span>
                    )}
                    {!props.informationData.addres && (
                        <span>
                            Não divulgamos publicamente o endereço de nossos abrigos. 
                            Lamentavelmente o número de abandonos em nossas portas ainda 
                            é alto. Para aqueles que abandonam seus animais, informamos 
                            que instalamos câmeras de segurança em todos os nossos espaços.
                        </span>
                    )}
                </div>
            </div>
        </div>
          </footer>

        </>
    )
}